module.exports = __webpack_public_path__ + "img/numeralia_cedis_1.f54f78c3.png";